import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";

const Button = ({
    classOption = "btn",
    text,
    path,
    link = "",
    target = "",
    id,
    ariaLabelledBy,
}) => {
    if (path) {
        return (
            <React.Fragment>
                <Link
                    id={id}
                    to={process.env.PUBLIC_URL + path}
                    className={`${classOption}`}
                    target={target}
                    aria-labelledby={ariaLabelledBy}
                >
                    {text}
                </Link>
            </React.Fragment>
        );
    } else if (link) {
        return (
            <React.Fragment>
                <Link
                    id={id}
                    target="_blank"
                    rel="noopener noreferrer"
                    to={{
                        pathname: link,
                    }}
                    className={`${classOption}`}
                    aria-labelledby={ariaLabelledBy}
                >
                    {text}
                </Link>
            </React.Fragment>
        );
    }
    return null;
};

Button.propTypes = {
    classOption: PropTypes.string,
    text: PropTypes.string,
    path: PropTypes.string,
    link: PropTypes.string,
    target: PropTypes.string,
    id: PropTypes.string,
    ariaLabelledBy: PropTypes.string,
};

export default Button;
